// Modules
import menu from './modules/menu'
import search from './modules/search'
import scrolled from './modules/scrolled'
import parallax from './modules/parallax'
import sticky from './modules/sticky'
import filterEvents from "./modules/filters";
import loadMore from "./modules/load-more";

// Initialise
function init() {
  scrolled();
  menu();
  search();
  parallax();
  loadMore();
  filterEvents();
  sticky();
}

export default init;
